<template>
  <div>
    <el-dialog
        title="Liên kết tài khoản và tạo VA"
        :before-close="handleClose"
        :visible.sync="isOTPAuthenticationOCBDialog"
        :show-close="true"
        :close-on-click-modal="false"
        width="600px"
        @open="handleOpen"
    >
      <el-form
          label-width="140px"
          :model="formData"
          label-position="left"
          :rules="rules"
          ref="formData"
      >
        <el-form-item label="Tên trường" prop="merchant_name">
          <el-input v-model="formData.merchant_name" placeholder="Nhập tên trường" />
        </el-form-item>

        <el-form-item label="Email" prop="email">
          <el-input v-model="formData.email" placeholder="Nhập email" />
        </el-form-item>

        <el-form-item label="Địa chỉ trường" prop="merchant_address">
          <el-input
              maxlength="1000" show-word-limit
              type="textarea"
              v-model="formData.merchant_address"
              placeholder="Nhập địa chỉ trường"
          />
        </el-form-item>

        <el-form-item label="Số VA" prop="va">
          <el-input v-model="formData.va" placeholder="Nhập số VA" maxlength="15" show-word-limit disabled/>
        </el-form-item>

        <el-form-item label="Tên gợi nhớ" prop="label">
          <el-input
              v-model="formData.label"
              placeholder="Nhập tên gợi nhớ"
              maxlength="100"
              show-word-limit
          />
        </el-form-item>
        <el-form-item label="Nhập mã OTP" prop="otp">
          <el-input v-model="formData.otp" placeholder="Nhập mã OTP" style="width: 300px;"></el-input>
          <el-button
              :disabled="!canRequestOTP || showResendOTP"
              type="success"
              size="medium"
              @click="getOTP"
          >
            <i class="el-icon-circle-check"/>
            <span>Lấy OTP</span>
          </el-button>
        </el-form-item>
      </el-form>
      <div>
             <span slot="footer" class="dialog-footer">
          <el-button
              style="width: 100%"
              type="primary"
              size="medium"
              :loading="loading.submit"
              @click="submitForm"
          >
            <i class="el-icon-circle-check"/>
            <span>Liên kết</span>
          </el-button>
      </span>
      </div>
      <div style="margin-top: 20px; text-align: center; font-size: 14px">
        Trong trường hợp không nhận được mã OTP hoặc mã OTP hết hiệu lực, bạn có thể nhấn
        <el-button
            type="primary"
            size="medium"
            :disabled="countdown > 0"
            @click="resendOTP"
            style="min-width: 100px"
        >
          {{ countdown > 0 ? `Gửi lại mã (${countdown}s)` : 'Gửi lại mã' }}
        </el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "OTPAuthenticationAndVAToOCBDialog",
  props: {
    isOTPAuthenticationOCBDialog: {
      type: Boolean,
      default: () => false
    },
    bank: {
      type: Object,
      default: () => null
    },
  },

  data() {
    const textPattern = /^[a-zA-Z0-9\s-]+$/;
    const vaPattern = /^[A-Z0-9]+$/;
    return {
      formData: {
        bank_account_id: '',
        company_id: '',
        merchant_name: '',
        email: '',
        merchant_address: '',
        va: '',
        label: '',
        otp: "",
        request_id: ""
      },
      countdown: 90,
      resendAvailable: false,
      showResendOTP: false,
      timer: null,
      rules: {
        otp: [
          {
            required: true,
            message: "Mã OTP không được để trống!",
            trigger: "change",
          },
        ],
        merchant_name: [
          { required: true, message: 'Vui lòng nhập tên điểm bán', trigger: 'change' },
          { min: 1, max: 500, message: 'Độ dài 1-500 ký tự', trigger: 'change' },
          { pattern: textPattern, message: 'Chỉ chấp nhận chữ, số, khoảng trắng, dấu gạch', trigger: 'change' }
        ],
        email: [
          { required: true, message: 'Vui lòng nhập email', trigger: 'change' },
          { type: 'email', message: 'Email không hợp lệ', trigger: 'change' }
        ],
        merchant_address: [
          { required: true, message: 'Vui lòng nhập địa chỉ', trigger: 'change' },
          { min: 1, max: 1000, message: 'Độ dài 1-1000 ký tự', trigger: 'change' },
          { pattern: textPattern, message: 'Chỉ chấp nhận chữ, số, khoảng trắng, dấu gạch ngang', trigger: 'change' }
        ],
        va: [
          { required: true, message: 'Vui lòng nhập số VA', trigger: 'change' },
          { min: 1, max: 15, message: 'Độ dài 1-15 ký tự', trigger: 'change' },
          { pattern: vaPattern, message: 'Chỉ chấp nhận chữ in hoa và số', trigger: 'change' }
        ],
        label: [
          { max: 100, message: 'Tối đa 100 ký tự', trigger: 'change' }
        ],
      },
      loading: {
        submit: false,
      },
    }
  },
  computed: {
    canRequestOTP() {
      const { merchant_name, email, merchant_address, va } = this.formData;
      const nameValid = merchant_name && merchant_name.length <= 500 && /^[a-zA-Z0-9\s-]+$/.test(merchant_name);
      const emailValid = this.rules.email.every(rule => {
        if (rule.type === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        return email && email.length > 0;
      });
      const addressValid = merchant_address && merchant_address.length <= 1000 && /^[a-zA-Z0-9\s-]+$/.test(merchant_address);
      const vaValid = va && va.length <= 15 && /^[A-Z0-9]+$/.test(va);

      return nameValid && emailValid && addressValid && vaValid;
    },
    ... mapGetters("schoolStore",["schoolData"])
  },
  created() {
    this.$store.dispatch('schoolStore/fetchDataSchoolData');
  },
  methods: {
    handleClose() {
      this.$refs["formData"].resetFields();
      this.showResendOTP = false;
      this.resendAvailable = false;
      this.$emit("closeDialog");
    },
    handleCloseAll() {
      this.$refs["formData"].resetFields();
      this.showResendOTP = false;
      this.resendAvailable = false;
      this.$emit("closeDialogAll");
    },
    getOTP(){
      sePayConnectionService.sendRequestCreateBankOCBAccount(this.formData).then(res => {
        if (res.data.data.code === "200") {
          this.formData.request_id = res.data.data.data.request_id
          NotifyMessage.leftCornerNotificationSuccess(res.data.data.message)
        } else {
          NotifyMessage.leftCornerNotificationError(res.data.data.message)
        }
      })
      this.startCountdown();
    },
    /**
     * Khởi tạo số VA
     */
    async initializationVANumberOCB(){
      await sePayConnectionService.initializationVANumberOCB().then(res => {
        this.formData.va = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    async handleOpen() {
      await this.initializationVANumberOCB()
      this.formData.bank_account_id = this.bank.idBankAccount
      this.formData.company_id = this.bank.idCompany
      this.formData.merchant_name = this.schoolData.schoolName
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-zA-Z0-9\s-]/g, '')
          .trim();
      this.formData.email = this.schoolData.schoolEmail
      this.formData.merchant_address = this.schoolData.schoolAddress
          .normalize('NFD')                    // Tách dấu tiếng Việt (é → e + ́)
          .replace(/[\u0300-\u036f]/g, '')     // Xóa dấu tiếng Việt
          .replace(/[^a-zA-Z0-9\s-]/g, '')    // Chỉ giữ a-z, A-Z, 0-9, space, -
          .trim();

    },
    startCountdown() {
      this.resendAvailable = false;
      this.showResendOTP = true;
      this.countdown = 90;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.resendAvailable = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    resendOTP() {
      this.getOTP()
      this.startCountdown(); // Bắt đầu đếm lại từ đầu
    },
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          await sePayConnectionService.confirmRequestCreateBankOCBAccount(this.formData).then(res => {
            if (res.data.data.code === "201") {
              NotifyMessage.leftCornerNotificationSuccess(res.data.data.message)
              this.loading.submit = false;
              this.handleCloseAll()
            } else {
              NotifyMessage.leftCornerNotificationError(res.data.data.message)
              this.loading.submit = false;
              this.handleCloseAll()
            }
          }).catch(error => {
            console.log(error)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  text-align: left;
  color: #167de7;
  font-weight: bold;
}
</style>